import { Route, Routes } from "react-router-dom";
import { OSCI0202001Q } from "@/tz/go/egaz/osci/lpco/cscl/OSCI0202001Q";
import { OSCI0202002Q } from "@/tz/go/egaz/osci/lpco/cscl/OSCI0202002Q";
import { OSCI0202003Q } from "@/tz/go/egaz/osci/lpco/cscl/OSCI0202003Q";

export const OsciLpcoTansadRouter = () => {
    return (
        <Routes>
            {/*  !== LPCO 승인 ==! */}
            <Route path="/osci0202001q" element={<OSCI0202001Q />} />
            <Route path="/osci0202002q/:id" element={<OSCI0202002Q />} />
            <Route path="/osci0202003q/:id" element={<OSCI0202003Q />} />
        </Routes>
    );
};
